import clsx from 'clsx';

import style from './style.scss';

const roundNumber = (length) => {
  let count = null;

  if (length < 10) {
    count = length;
  } else if (length > 9) {
    count = '9+';
  }

  return count;
};
const RoundCount = ({ count, round = true, className }) => {
  return (
    <span className={clsx(style.roundCount, className)}>
      <span>{round ? roundNumber(count) : count}</span>
    </span>
  );
};

export default RoundCount;
